import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import { CommonConfig } from '../../../configs/config.common';
import HybirdCouponCard from '../../shared/HybridCouponCard/hybrid.coupon.card.vue';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
import { CouponMarketingListDelegate } from '../../services/DataDelegate/CouponDelegate/coupon.marketing.list.delegate';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import * as T_T from 'cryface';
import { Coupon } from '../../../hybrid/shared/HybridCouponCard/hybrid.coupon.card.component';
import * as moment from 'moment';
import CouponStatus from '../../mixins/coupon.status.mixin';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { getCondition } from '../../../utils/price.condition';
import { I18N } from '../../../utils/i18n/i18n';


@Component({
    components: {
        'layout': HybridBasicLayout,
        HybirdCouponCard,
        GoBackArrow
    },
    mixins: [CouponStatus],
})
export default class HybirdCouponMarketingList extends Vue {
    public configs = new CommonConfig();
    public list: Coupon[] = [];
    public couponMarketListing: CouponMarketingListDelegate = new CouponMarketingListDelegate();
    public userInfoDelegate = new UserInfoDelegate();
    public userInfo = null;
    public fjjUserId: number = -1;

    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            const fjjUserId = val.getParam('fjjUserId');
            if (T_T.simpleDetect(fjjUserId)) {
                this.fjjUserId = fjjUserId;
            }
        }
    }

    public getButtonText() {
        if (this.fjjUserId === -1) {
            return this.$t('20');
        } else {
            return this.$t('21');
        }
    }

    public onButtonPressed() {
        if (this.fjjUserId === -1 || !T_T.simpleDetect(this.fjjUserId)) {
            // CallNative.runNativeFun('nativeGoRegister');
            CallNative.runNativeFun('nativeGoRegister');
            // return '登陆/注册';
        } else {
            CallNative.runNativeFun('nativeGoMe');
            // this.$router.push('/hybrid/coupon/my/coupons');
        }
    }

    public async created() {
        CallNative.setNativeNavTitle('优惠券列表', 'Coupon List');
        await this.getList();
    }

    public mounted() {
    }

    public async getList() {
        const fetched = await this.couponMarketListing.getList();
        if (T_T.simpleDetect(fetched)) {
            if (fetched.errorCode === 200) {
                this.list = this.dataMapepr(fetched.data.list);
            }
        }
    }
    public dataMapepr(list: any[]): Coupon[] {
        const placeHolder = this.configs.housePicPlaceHolder;
        const self = this;
        const coupons = list.map((v: any) => {
            const condition = getCondition(
                v.xCategory,
                v.xDiscountPercent,
                v.xDiscountAmount,
                v.xRequestedAmount,
                self.$i18n.locale);
            const title = (self.$i18n.locale === I18N.EI18nLocale.Zn)
                ? v.xNameCn
                : (self.$i18n.locale === I18N.EI18nLocale.En) ? v.xNameEn : this.$t('18');
            const slogan = (self.$i18n.locale === I18N.EI18nLocale.En) ? v.xTagline : this.$t('19');
            const newCoupon: Coupon = {
                id: v.id,
                title: title,
                img: T_T.simpleDetect(v.coverImgs) ? v.coverImgs.length > 0 ? v.coverImgs[0] : placeHolder : placeHolder,
                slogan: slogan,
                expirationDate: T_T.simpleDetect(v.xExpiredDate) ? moment(v.xExpiredDate).format(this.configs.dateFormat) : '',
                price: T_T.simpleDetect(v.xPrice) ? v.xPrice : '0',
                condition: condition
            };
            return newCoupon;
        });
        return coupons;
    }

    // public async getUserInfo() {
    //     if (this.fjjUserId) {
    //         const userInfo = await this.userInfoDelegate.getUserInfo(this.fjjUserId);
    //         if (userInfo) {
    //             this.userInfo = userInfo;
    //         }
    //     }
    // }
}
